// extracted by mini-css-extract-plugin
export default {"highlightRow":"AssignDestsTable_highlightRow__kYlWo"};